var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.suportado)?_c('p',[_vm._v("Chamada de voz não suportada nesse dispostivo.")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }